<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6762 1.20093C12.6922 1.20206 12.7086 1.20125 12.7244 1.20431C12.7818 1.21547 12.8165 1.23093 12.8422 1.28391C12.8884 1.37918 12.883 5.17365 12.8524 5.53905C12.8283 5.79817 12.7676 6.0526 12.6724 6.29478C12.577 6.53817 12.367 6.77248 12.1916 6.96189C11.5066 7.70174 3.90251 15.293 3.78519 15.3325C3.73632 15.3488 3.71801 15.3331 3.67627 15.3114C3.58305 15.0864 3.62001 13.7616 3.6215 13.4227L3.62191 8.15395C3.62203 7.78718 3.59119 5.63247 3.66356 5.49649C3.72136 5.45749 3.73386 5.42799 3.79596 5.45503C3.97188 5.53934 4.09787 5.70845 4.23837 5.84536C4.77542 6.36867 5.27994 6.94832 5.84572 7.43837C6.00956 7.58029 6.2453 7.60427 6.41204 7.44935C6.66061 7.21843 6.90249 6.97325 7.14538 6.73031L8.46065 5.41463L12.6762 1.20093Z"
      :fill="color"
    />
    <path
      d="M16.2054 4.69897C16.32 4.72996 16.2737 4.70064 16.3509 4.78744C16.4105 5.00122 16.3776 7.35406 16.3776 7.79208L16.3782 12.4163C16.3779 12.6976 16.4111 14.386 16.3416 14.5671C16.2986 14.6048 16.2924 14.6267 16.2318 14.6107C15.8305 14.5038 14.3302 12.4703 13.8306 12.4878C13.7151 12.4917 13.5862 12.6157 13.5019 12.6899C12.9049 13.2161 12.3538 13.8263 11.7899 14.3905L8.43828 17.7432C8.14557 18.0365 7.86038 18.3424 7.56183 18.6297C7.45006 18.7372 7.29991 18.8728 7.16199 18.7511C7.09546 18.5677 7.15335 15.3722 7.1331 14.9199C7.11253 14.4608 7.227 13.8343 7.51403 13.4458C7.76479 13.1063 8.14843 12.7493 8.45553 12.4421L10.0683 10.8306L16.2054 4.69897Z"
      :fill="color"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    color: {
      type: String,
      default: "white",
    },
  },
})
</script>

<style></style>
